import { useTranslation } from 'react-i18next';
import { AdviceCard } from './AdviceCard';
import type { AdviceKey } from './AdviceKey';
import { adviceText } from './adviceText';
import type { IAiAdviceProps } from './IAiAdviceProps';

/**
 * «Поради ШІ» (прототип v4 isAdvisory): усі поради модуля у тонах важливості; дії — «Показати прострочені» / «Показати без виконавця»
 * (пункт меню з пресетом) і «Матриця ризиків» для відкритих критичних ризиків. Кнопки «Порадитися з ШІ» немає, доки сервер ШІ не під'єднано
 * (як прототип без window.claude).
 */
export function AiAdvice({ items, linkOf, matrixTo, stageLabel }: IAiAdviceProps) {
  const { t } = useTranslation();
  const actionOf = (key: AdviceKey) => {
    const to = key === 'overdue' ? linkOf('overdue') : key === 'unassigned' ? linkOf('unassigned') : key === 'critical' ? matrixTo : undefined;
    const label = key === 'overdue' ? 'showOverdue' : key === 'unassigned' ? 'showUnassigned' : 'riskMatrix';
    return to ? { to, label: t(`modBody.advice.${label}`) } : undefined;
  };
  return (
    <section className="mp-panel">
      <strong className="mp-panel__title mp-panel__title--lg">{t('advisory.ai')}</strong>
      {items.map((item) => <AdviceCard key={item.key} item={item} text={adviceText(item, t, stageLabel)} action={actionOf(item.key)} />)}
    </section>
  );
}
